import { gql } from '@apollo/client';

export const insertEraCareNotificationMutation = gql`
  mutation ($object: era_care_notifications_insert_input!) {
    insert_era_care_notifications_one(object: $object) {
      id
    }
  }
`;
